module.exports = __webpack_public_path__ + "static/media/logo-mono-iglu.11c07a4a.svg";